export const GA_ID = 'G-YQQG7TJVRY';

export function enableAnalytics() {
  if (typeof window === 'undefined') return;

  window[`ga-disable-${GA_ID}`] = false;
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }

  if (window.__gaLoaded) {
    window.gtag('consent', 'update', { analytics_storage: 'granted' });
    return;
  }
  window.__gaLoaded = true;

  window.gtag('consent', 'default', {
    analytics_storage: 'granted',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

export function disableAnalytics() {
  if (typeof window === 'undefined') return;

  window[`ga-disable-${GA_ID}`] = true;
  if (window.gtag) {
    window.gtag('consent', 'update', { analytics_storage: 'denied' });
  }

  // vorhandene GA-Cookies löschen
  const host = window.location.hostname.replace(/^www\./, '');
  document.cookie.split(';').forEach((c) => {
    const name = c.split('=')[0].trim();
    if (name === '_ga' || name.startsWith('_ga_')) {
      const expired = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
      document.cookie = expired;
      document.cookie = `${expired}; domain=.${host}`;
    }
  });
}